import { render } from "./CatalogButtonPanel.vue?vue&type=template&id=0dbf70d9&scoped=true"
import script from "./CatalogButtonPanel.vue?vue&type=script&lang=js"
export * from "./CatalogButtonPanel.vue?vue&type=script&lang=js"

import "./CatalogButtonPanel.vue?vue&type=style&index=0&id=0dbf70d9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dbf70d9"]])

export default __exports__